/*                                                                           */
import.meta.glob("./common/performance.start.ts", { eager: true });

import { isOnexVariant } from "@otto-ec/global-resources/onex";
import { initComplete } from "./common/performance.end";

import "@otto-ec/design-tokens/theme/theme.scss";

import.meta.glob("./common/extendCustomElement.ts", { eager: true });
import.meta.glob("./css-only-components/**/*.global.scss", { eager: true });
import.meta.glob("./fragments/**/*.global.scss", { eager: true });
import.meta.glob("./components/**/*.global.scss", { eager: true });

/*                                                                        */
import.meta.glob("./components/**/*.sync.svelte", { eager: true });

/*                                      */
initComplete();

if (isOnexVariant("E3619", "Testgroup")) {
  document.documentElement.dataset.onex = "yeah";
}
